import api from './client';
import type { SugestaoMeta, SugestaoMetaFiltros, SugestaoMetaResponse } from '../types/metaSugestao';

export const metaSugestaoApi = {
  calcular: async (filtros: SugestaoMetaFiltros): Promise<SugestaoMeta> => {
    const params = new URLSearchParams();
    filtros.empresas.forEach((e) => params.append('empresa', e));
    if (filtros.dimensao) params.set('dimensao', filtros.dimensao);
    if (filtros.codigo) params.set('codigo', filtros.codigo);
    const resp = await api.get<SugestaoMetaResponse>(`/compras/metas/sugestao?${params.toString()}`);
    return resp.data.data;
  },
};
